import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import {
  lineItemReasonTypes,
  lineItemRefs,
  lineQuantityMisurements,
} from 'src/app/utils/constants/strings';
import { ConfigService } from '../../../shared/services/config.service';
import { createConfigArray } from '../../../utils/default-configs/configuration';
import { configurationIdMapForLineItems } from '../../../utils/constants/constant';
import { countryList } from 'src/app/utils/constants/utility';
import { BehaviourService } from 'src/app/shared/services/behaviour.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateAddressComponent } from '../../address/create-address/create-address.component';
import { AddressService } from '../../address/service/address/address.service';
@Component({
  selector: 'app-line-item',
  templateUrl: './line-item.component.html',
  styleUrls: ['./line-item.component.scss'],
})
export class LineItemComponent implements OnInit, OnChanges {
  @Output() rowDeleted = new EventEmitter<boolean>();
  @Input() configurationLineItem: any;
  @Input() shipmentForm: FormGroup;
  LineDataSource = new MatTableDataSource<any>();
  @Input() shipmentData: any;
  @Input() decimalValue: any;
  @Input() currencyValues;
  @Input() additionalPartiesListFromShipment;
  patchValueExist = [];
  totalGrossWeight = 0;
  totalNetWeight = 0;
  totalLineItemValue = 0;
  tooltipUnitPriceValue = '';
  additionalPartiesList: any[] = [];
  columns: string[] = [
    'lineItemNumber',
    'lineItemDescription',
    'lineItemUnitPrice',
    'lineItemUnitPriceCurrency',
    'lineItemQuantity',
    'lineItemQuantityUnitofMeasurement',
    'lineItemExportCommodityCode',
    'lineItemImportCommodityCode',
    'lineItemExportReasonType',
    'lineItemPartNumber',
    'lineItemReference',
    'lineItemManufactureCountry',
    'lineItemNetWeight',
    'lineItemGrossWeight',
    'Action',
  ];
  lineQuantityMisurements = lineQuantityMisurements;
  lineItemReasonTypes = lineItemReasonTypes;
  lineItemRefs = lineItemRefs;
  list = countryList;
  disableLineItemCurr = false;
  mismatchInCurrency: boolean;
  errorMsg: string;
  constructor(
    private fb: FormBuilder,
    private configService: ConfigService,
    private behaviourService: BehaviourService,
    private translate: TranslateService,
    private dialog: MatDialog,
    private addressService: AddressService
  ) {}

  ngOnInit(): void {
    this.checkChanges();
    this.getLineItemProductValues();
    this.getToolTipValue();
    this.additionalPartiesList = this.additionalPartiesListFromShipment || [];
    const invoiceDetails = this.shipmentForm.get('invoiceDetails');

    invoiceDetails?.get('iossNumber')?.valueChanges.subscribe(value => {
      const countryControl = invoiceDetails.get('iossIssuerCountryCode');

      if (value?.trim()) {
        countryControl?.setValidators([Validators.required]);
      } else {
        countryControl?.clearValidators();
      }

      countryControl?.updateValueAndValidity();
    });
  }

  getToolTipValue() {
    if (this.decimalValue) {
      this.translate
        .get('shipment.lineItem.lineItemUnitPrice', { value: this.decimalValue })
        .subscribe((res: string) => {
          this.tooltipUnitPriceValue = res; // Store the translated value
        });
    } else {
      this.tooltipUnitPriceValue = ''; // Reset the value if there's no decimalValue
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'shipmentData':
            if (
              this.shipmentData.invoiceDetails != undefined &&
              this.shipmentData.invoiceDetails.lineItems.length > 0
            ) {
              this.LineDataSource = new MatTableDataSource();
              this.LineDataSource = new MatTableDataSource(
                (this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray).controls
              );
            } else {
              const lineItemsLength = (
                this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray
              ).controls;
              if (lineItemsLength && lineItemsLength.length === 0) {
                this.AddNewLineItem();
              }
              this.LineDataSource = new MatTableDataSource();
              this.LineDataSource = new MatTableDataSource(
                (this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray).controls
              );
            }
            this.setObjectIndex();
            break;
        }
      }
    }
  }

  checkChanges() {
    if (
      this.shipmentData.invoiceDetails != undefined &&
      this.shipmentData.invoiceDetails.lineItems.length > 0
    ) {
      this.LineDataSource = new MatTableDataSource(
        (this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray).controls
      );
      this.setTotalWeight();
    }
  }

  isValueExist(arrayData, value) {
    return arrayData.includes(value);
  }

  AddNewLineItem() {
    if (
      (this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray).controls.length > 0
    ) {
      this.disableLineItemCurr = true;
    }
    if (this.shipmentData.status != 'Manifested') {
      const control = this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray;
      control.insert(
        (this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray).controls.length + 1,
        this.addLineItemGroup()
      );
      this.setObjectIndex();
      this.LineDataSource = new MatTableDataSource(control.controls);
    }
    this.setTotalWeight();
  }

  DeleteLineItem(_formElement, i) {
    if (this.shipmentData.status != 'Manifested') {
      const control = this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray;
      control.removeAt(i);
      this.setObjectIndex();
      this.LineDataSource = new MatTableDataSource(
        (this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray).controls
      );
      this.rowDeleted.emit(true);
    }
    this.setTotalWeight();
  }

  private addLineItemGroup(): FormGroup {
    return this.fb.group({
      lineItemNumber: new FormControl(
        { value: '', disabled: true },
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.min(1),
          Validators.max(999),
        ])
      ),
      lineItemDescription: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(170)])
      ),
      lineItemPartNumber: new FormControl(''),
      lineItemReference: new FormControl(''),
      lineItemUnitPrice: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.min(0.00001),
          Validators.pattern('^[0-9]+(.[0-9]{0,' + this.decimalValue + '})?$'),
        ])
      ),
      lineItemUnitPriceCurrency: new FormControl(
        { value: '', disabled: this.disableLineItemCurr },
        Validators.compose([Validators.required])
      ),
      lineItemQuantity: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.pattern('^[0-9]*$'), Validators.min(1)])
      ),
      lineItemQuantityUnitofMeasurement: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      lineItemExportCommodityCode: new FormControl(''),
      lineItemImportCommodityCode: new FormControl(''),
      lineItemExportReasonType: new FormControl('', Validators.required),
      lineItemManufactureCountry: new FormControl(
        '',
        Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(2)])
      ),
      lineItemNetWeight: new FormControl(
        0.1,
        Validators.compose([
          Validators.required,
          Validators.min(0.001),
          Validators.max(999999999999),
          Validators.pattern('^[0-9]+(.[0-9]{0,3})?$'),
        ])
      ),
      lineItemGrossWeight: new FormControl(
        0.1,
        Validators.compose([
          Validators.required,
          Validators.min(0.001),
          Validators.max(999999999999),
          Validators.pattern('^[0-9]+(.[0-9]{0,3})?$'),
        ])
      ),
    });
  }

  getLineFormControlId(id, control) {
    const controlForm = (
      this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray
    ).controls[id].get(control);
    return controlForm;
  }

  setObjectIndex() {
    (this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray).controls.forEach(
      (currentValue, Index) => {
        currentValue.get('lineItemNumber').setValue(Index + 1);
        this.patchValueExist.length > 0
          ? this.patchValueBasedOnExist(currentValue)
          : this.getDefaultConfiguration(currentValue);
      }
    );
  }

  patchValueBasedOnExist(currentValue) {
    this.patchValueExist.forEach(item => {
      this.patchValueToFormsInLineItems(item?.config_id, item?.data, currentValue);
    });
  }

  getDefaultConfiguration(currentValue) {
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForLineItems))
      .then(response => {
        this.patchValueExist = response;
        response.forEach(item => {
          this.patchValueToFormsInLineItems(item?.config_id, item?.data, currentValue);
        });
      });
  }

  patchValueToFormsInLineItems(formName, formData, currentValue) {
    if (!currentValue.get('lineItemReference').value) {
      currentValue.get('lineItemReference').setValue('PAN');
    }
    const formConfigs = {
      default: () => ``,
      default_countryofmanufacture: () => {
        if (!currentValue.get('lineItemManufactureCountry').value) {
          currentValue.get('lineItemManufactureCountry').setValue(formData[0]?.manufactureCountry);
        }
      },
      mother_exportdeclarationdetails: () => {
        if (!currentValue.get('lineItemExportReasonType').value) {
          currentValue
            .get('lineItemExportReasonType')
            .setValue(formData[0]?.content.exportDeclaration.exportReason);
        }
      },
      default_unitofmeasurement: () => {
        if (!currentValue.get('lineItemQuantityUnitofMeasurement').value) {
          currentValue
            .get('lineItemQuantityUnitofMeasurement')
            .setValue(formData[0]?.lineItemQuantityUnitofMeasurement);
        }
      },
      default_currency: () => {
        this.setAllCurrencies(currentValue, formData);
        this.setTotalWeight();
        this.checkMismatch();
      },
    };
    return (formConfigs[formName] || formConfigs.default)();
  }

  getLineItemProductValues() {
    this.shipmentForm.controls?.['invoiceDetails']?.valueChanges.subscribe(data => {
      this.behaviourService.sendEvent(data);
    });

    this.checkLineItemShipmentData();
  }

  onCurrencyChange(event) {
    this.setAllLineItemCurrency(event);
    this.matchLineItemShipmentDeclCurrency(event);
  }

  setAllLineItemCurrency(event) {
    (this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray).controls.forEach(
      currentValue => {
        if (
          (this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray).controls.length >
          0
        ) {
          currentValue.get('lineItemUnitPriceCurrency').setValue(event);
        }
      }
    );
  }

  matchLineItemShipmentDeclCurrency(event) {
    if (this.shipmentForm.value.shipmentDeclaredValueCurrency !== event) {
      this.mismatchInCurrency = true;
      this.errorMsg = 'Line item currency should match with Shipment Declared Value Currency';
    } else {
      this.mismatchInCurrency = false;
    }
    this.behaviourService.sendEvent(this.mismatchInCurrency);
  }

  checkAllLineItemCurrencySame(event) {
    const lineItemsArray = this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray;
    if (lineItemsArray.length > 1) {
      const firstCurrency = lineItemsArray.at(0).get('lineItemUnitPriceCurrency').value;
      let mismatchFound = false;
      lineItemsArray.controls.forEach((currentValue: FormGroup, index: number) => {
        if (index !== 0) {
          const currentCurrency = currentValue.get('lineItemUnitPriceCurrency').value;
          if (firstCurrency !== currentCurrency) {
            mismatchFound = true;
            return;
          }
        }
      });
      this.mismatchInCurrency = mismatchFound;
      if (this.mismatchInCurrency) {
        this.errorMsg = 'Line item currency should be same for all line items';
      }
    }
  }

  checkLineItemShipmentData() {
    this.behaviourService?.currentMessage?.subscribe((data: any) => {
      if (data && data?.shipmentDeclaredValueCurrency) {
        if (
          this.shipmentForm?.value?.lineItems &&
          this.shipmentForm?.value?.lineItems[0]?.lineItemUnitPriceCurrency &&
          this.shipmentForm?.value?.lineItems[0]?.lineItemUnitPriceCurrency !==
            data?.shipmentDeclaredValueCurrency
        ) {
          this.mismatchInCurrency = true;
        } else {
          this.mismatchInCurrency = false;
        }
      } else if (typeof data == 'boolean') {
        {
          if (data === true) {
            this.checkMismatchScenario();
          } else {
            this.mismatchInCurrency = false;
          }
        }
      }
    });
  }

  setAllCurrencies(currentValue, formData) {
    const firstICurrVal = this.shipmentForm?.get('invoiceDetails')?.get('lineItems')
      ?.value[0]?.lineItemUnitPriceCurrency;

    if (
      this.shipmentForm?.get('invoiceDetails')?.get('lineItems').value.length > 0 &&
      firstICurrVal != '' &&
      currentValue.get('lineItemUnitPriceCurrency').value == ''
    ) {
      currentValue.get('lineItemUnitPriceCurrency').setValue(firstICurrVal);
    } else if (!firstICurrVal) {
      currentValue.get('lineItemUnitPriceCurrency').setValue(formData[0]?.declaredValueCurrency);
    }
  }

  checkMismatch() {
    const lineItemsArray = this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray;
    if (lineItemsArray.length > 1) {
      this.checkMismatchScenario();
      this.behaviourService.sendEvent(this.mismatchInCurrency);
    }
  }

  checkMismatchScenario() {
    const lineItemsArray = this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray;
    if (lineItemsArray.length > 1) {
      const firstCurrency = lineItemsArray.at(0).get('lineItemUnitPriceCurrency').value;
      let mismatchFound = false;

      lineItemsArray.controls.forEach((currentValue: FormGroup, index: number) => {
        if (index !== 0) {
          const currentCurrency = currentValue.get('lineItemUnitPriceCurrency').value;
          if (firstCurrency !== currentCurrency) {
            mismatchFound = true;
            return;
          }
        }
      });
      this.mismatchInCurrency = mismatchFound;
      if (this.mismatchInCurrency) {
        this.errorMsg = 'Line item currency should be same for all line items';
      } else if (this.shipmentForm.value.shipmentDeclaredValueCurrency !== firstCurrency) {
        this.mismatchInCurrency = true;
        this.errorMsg = 'Line item currency should match with Shipment Declared Value Currency';
      } else {
        this.mismatchInCurrency = false;
      }
    }
  }
  setTotalWeight() {
    this.totalGrossWeight = 0;
    this.totalNetWeight = 0;
    this.totalLineItemValue = 0;
    const lineItemsArray = this.shipmentForm.get('invoiceDetails').get('lineItems') as FormArray;
    if (lineItemsArray.controls.length > 0) {
      lineItemsArray.controls.forEach((lineItem: FormGroup) => {
        this.totalGrossWeight += Number(lineItem.value.lineItemGrossWeight);
        this.totalGrossWeight = Math.round(this.totalGrossWeight * 1000) / 1000;
        this.totalNetWeight += Number(lineItem.value.lineItemNetWeight);
        this.totalNetWeight = Math.round(this.totalNetWeight * 1000) / 1000;
        this.totalLineItemValue =
          this.totalLineItemValue +
          Number(lineItem.value.lineItemQuantity) * Number(lineItem.value.lineItemUnitPrice);
        this.totalLineItemValue = Math.round(this.totalLineItemValue * 1000) / 1000;
      });
    }
  }

  openAddPartiesPopup() {
    const sellerCount = this.additionalPartiesList.filter(
      party => party.addressType === 'SELLER'
    ).length;
    const buyerCount = this.additionalPartiesList.filter(
      party => party.addressType === 'BUYER'
    ).length;
    const addPartiesDialogRef = this.dialog.open(CreateAddressComponent, {
      maxHeight: '60vw',
      maxWidth: '60vw',
      data: {
        openedFrom: 'addParties',
        buyerCount: buyerCount,
        sellerCount: sellerCount,
      },
    });
    addPartiesDialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result._addressType === 'SELLER') {
          this.shipmentForm.get('seller_id')?.setValue(result._addressID);
          const seller = result._addressDetails;
          this.additionalPartiesList.push({
            address_id: result._addressID,
            addressType: result._addressType,
            contactPersonName: seller.sellerContactPersonName,
            companyName: seller.sellerCompanyName,
            addressLine1: seller.sellerAddressLine1,
            city: seller.sellerCityName,
            postalCode: seller.sellerPostalCode,
            CountryName: seller.sellerCountryName,
          });
        } else if (result._addressType === 'BUYER') {
          this.shipmentForm.get('buyer_id')?.setValue(result._addressID);
          const buyer = result._addressDetails;
          this.additionalPartiesList.push({
            address_id: result._addressID,
            addressType: result._addressType,
            contactPersonName: buyer.buyerContactPersonName,
            companyName: buyer.buyerCompanyName,
            addressLine1: buyer.buyerAddressLine1,
            city: buyer.buyerCityName,
            postalCode: buyer.buyerPostalCode,
            CountryName: buyer.buyerCountryName,
          });
        }
      }
    });
  }

  deleteParty(address_id) {
    const reqBody = {
      body: { address_id: [address_id] },
    };
    this.addressService.deleteAddress(reqBody).subscribe(() => {
      this.additionalPartiesList = this.additionalPartiesList.filter(
        item => item.address_id !== address_id
      );
    });
  }

  isBothAdded(): boolean {
    return (
      this.additionalPartiesList?.some(x => x.addressType === 'SELLER') &&
      this.additionalPartiesList?.some(x => x.addressType === 'BUYER')
    );
  }

  getTooltip(): string {
    return this.isBothAdded()
      ? 'shipment.lineItem.onlyOneByuerOrSeller'
      : 'shipment.lineItem.addParties';
  }
}
